"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateDefaultIfRules = evaluateDefaultIfRules;
exports.evaluateDefaultValueParams = evaluateDefaultValueParams;
exports.getConditionalDefaultValueForField = getConditionalDefaultValueForField;
const defaultIfRule_1 = require("./defaultIfRule");
const evaluateConditions_1 = require("../../../condition-engine/evaluateConditions");
const queries_1 = require("../../../condition-engine/queries");
function evaluateDefaultIfRules(rules, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride) {
    const firstConditionToPass = rules.find((rule) => {
        if (rule.conditions === null)
            return true;
        return (0, evaluateConditions_1.evaluateConditions)(rule.conditions, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride).isValid;
    });
    return firstConditionToPass;
}
function evaluateDefaultValueParams(defaultValue, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride) {
    if ((0, defaultIfRule_1.isDefaultValueQuery)(defaultValue)) {
        return (0, queries_1.evaluateQuery)(defaultValue.fromQuery, answersResolver, repeatedInstanceIdentifiers, timezone, {}, currentDateOverride);
    }
    return defaultValue;
}
function getConditionalDefaultValueForField(rules, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride) {
    const defaultIfCondition = evaluateDefaultIfRules(rules, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride);
    if (!defaultIfCondition)
        return;
    const defaultFieldValue = evaluateDefaultValueParams(defaultIfCondition.defaultValue, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride);
    return defaultFieldValue;
}
